<template>
	<nut-navbar
		class="navbar"
		title="中奖·兑奖"
		desc="扫对方"
		leftShow
		@on-click-back="goBack"
		@on-click-right="handleScan"
	>
	</nut-navbar>
	<div>
		<div class="qrcode-container">
			<div class="qrcode" ref="qrcodeRef"></div>
			<div class="tip">
				<span class="alertInfo"
					>中奖顾客扫描此二维码完成兑换验证！</span
				>
				<nut-icon
					class="icon"
					class-prefix="icon"
					font-class-name="iconfont"
					name="question-circle"
					@click="handleOpenDialog(CASH_PRIZE_HELP)"
				></nut-icon>
			</div>
		</div>

		<nut-tabs class="tabs" v-model="tabVal">
			<nut-tabpane title="未兑奖" pane-key="won">
				<div class="scroll" id="scrollContainer">
					<nut-infiniteloading
						containerId="scrollContainer"
						:use-window="false"
						:is-open-refresh="true"
						:has-more="hasMore"
						@load-more="handleLoadMore"
						@refresh="handleRefresh"
						pull-icon="loading1"
						load-icon="loading1"
						load-more-txt="已经到底部啦～"
					>
						<prize-item
							v-for="item in list"
							:key="item.id"
							:data="item"
						>
						</prize-item>
					</nut-infiniteloading>
				</div>
			</nut-tabpane>
			<nut-tabpane title="已兑奖" pane-key="paid">
				<div class="scroll" id="scrollContainer1">
					<nut-infiniteloading
						containerId="scrollContainer1"
						:use-window="false"
						:is-open-refresh="true"
						:has-more="hasMore"
						@load-more="handleLoadMore"
						@refresh="handleRefresh"
						pull-icon="loading1"
						load-icon="loading1"
						load-more-txt="已经到底部啦～"
					>
						<prize-item
							v-for="item in list"
							:key="item.id"
							:data="item"
						>
						</prize-item>
					</nut-infiniteloading>
				</div>
			</nut-tabpane>
		</nut-tabs>
	</div>
	<prize-info-modal
		v-model="infoVisible"
		:data="prizeData"
	></prize-info-modal>
</template>

<script>
import { ref, onMounted, watch, reactive, toRefs } from 'vue';
import wx from 'weixin-js-sdk';
import QRCode from 'qrcodejs2';
import PrizeItem from './components/prizeItem';
import PrizeInfoModal from './components/priceInfoModal';
import useNavigate from '@/hooks/useNavigate';
import useDialog from '@/hooks/useDialog';
import { CASH_PRIZE_HELP } from '@/constants/tiptype';
import { exchangeApi, siteApi } from '@/apis';
import { getConfigUrl } from '@/utils/util';

const limit = 15;
export default {
	name: 'Exchange',
	components: {
		PrizeItem,
		PrizeInfoModal,
	},
	setup() {
		const tabVal = ref('won');
		const list = ref([]);
		const offset = ref(0);
		const hasMore = ref(true);
		const qrcodeRef = ref(null);
		const prizeInfo = reactive({
			visible: false,
			prizeData: {},
		});
		const { goBack } = useNavigate();
		const { handleOpenDialog } = useDialog();

		const getInitData = async () => {
			const url = getConfigUrl();
			const res = await exchangeApi.exchange_index({ url });
			const {
				signpackage: {
					appId,
					timestamp,
					debug,
					nonceStr,
					signature,
					jsApiList,
				},
			} = res;
			wx.config({
				debug,
				appId,
				timestamp,
				nonceStr,
				signature,
				jsApiList,
			});
			new QRCode(qrcodeRef.value, {
				text: res.otc,
				width: 120,
				height: 120,
				colorDark: '#000000',
				colorLight: '#ffffff',
				correctLevel: QRCode.CorrectLevel.H,
			});
		};
		const getData = async () => {
			const res = await exchangeApi.exchange_load_data({
				type: tabVal.value,
				offset: offset.value,
				limit,
			});
			const data = res || [];
			list.value = offset.value === 0 ? data : [...list.value, ...data];
			hasMore.value = data.length >= limit;
		};

		const handleRefresh = async (done) => {
			offset.value = 0;
			await getData();
			done();
		};

		const handleLoadMore = async (done) => {
			offset.value += limit;
			await getData();
			done();
		};

		watch(tabVal, () => {
			offset.value = 0;
			list.value = [];
			getData();
		});

		onMounted(() => {
			getData();
			getInitData();
		});

		const handleScan = () => {
			wx.scanQRCode({
				needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
				scanType: ['qrCode'],
				success: async (res) => {
					const code = res.resultStr;
					try {
						// todo 待确认扫码返回值是啥
						const scanRes = await exchangeApi.do_exchange({
							code,
						});
						prizeInfo.visible = true;
						prizeInfo.prizeData = scanRes;
					} catch (error) {
						console.log(error);
					}
				},
				fail: (err) => {
					// 上报扫码调用失败原因
					siteApi.ajax_error({
						result: err.errMsg,
					});
				},
			});
		};
		return {
			qrcodeRef,
			tabVal,
			list,
			CASH_PRIZE_HELP,
			hasMore,
			...toRefs(prizeInfo),

			goBack,
			handleOpenDialog,
			handleRefresh,
			handleLoadMore,
			handleScan,
		};
	},
};
</script>

<style lang="scss" scoped>
.navbar {
	:deep(.nut-navbar__text) {
		color: #fff;
	}
}
.qrcode-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 10px;
	.qrcode {
		width: 120px;
		height: 120px;
	}

	.tip {
		align-self: stretch;
		position: relative;
		height: 20px;
		line-height: 20px;
		margin-top: 10px;
		color: #999;
		font-size: 12px;
		text-align: center;

		.icon {
			position: absolute;
			right: 0;
			top: 0;
		}
	}
}

.tabs {
	:deep(.nut-tabpane) {
		box-sizing: border-box;
		padding: 0;

		height: calc(100vh - 260px);
		overflow-x: hidden;
	}
}
.scroll {
	box-sizing: border-box;
	height: 100%;
	padding-bottom: 16px;
	overflow-y: scroll;
	overflow-x: hidden;
}
</style>
